import { useState, useCallback, useEffect } from 'react';
import { Container, BoxSelect, BtnSearch, Content, Card } from './styled';
import { apiAdmin } from '../../../../service/api';
import { DatePicker, Table } from '../../../../components';
import { RiCustomerService2Fill } from 'react-icons/ri';
import { IoIosSearch } from 'react-icons/io';
import { BiTransfer } from 'react-icons/bi';
import { FaUsers } from 'react-icons/fa';
import moment from 'moment';
import * as XLSX from 'xlsx';


export function Total() {

    const [dateStart, setDateStart] = useState(moment(`${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`).format('YYYY-MM-DD'));
    const [dateEnd, setDateEnd] = useState(moment(`${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`).format('YYYY-MM-DD'));
    const [qtd, setQtd] = useState({});
    const [data, setData] = useState([]);
    const [dataTable, setDataTable] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');


    const searchQTDCustomerservice = useCallback(async (dt_ini, dt_fim) => {
        setLoading(true)
        const { data: { data, totais } } = await apiAdmin.get(`/qtd-atendimentos?dt_ini=${dt_ini}&dt_fim=${dt_fim}`);
        setQtd(totais)
        setData(data)
        setDataTable(data)
        setLoading(false)
    }, []);
    useEffect(() => {
        searchQTDCustomerservice(moment(dateStart).format('DD/MM/YYYY'), moment(dateEnd).format('DD/MM/YYYY'))
    }, [])
    useEffect(() => {
        if (search) return
        setDataTable(data)
    }, [search])

    const clear = () => {
        setData([])
        setDataTable([])
        setQtd({})
    }

    const componentName = (rowData) => {
        return (
            <span className='column'>
                {rowData.usuario}
            </span>
        )
    }
    const componentTotalUsers = (rowData) => {
        return (
            <span className='column'>
                <FaUsers />
                {rowData.cliente_id}
            </span>
        )

    }
    const componentTotalCustomerService = (rowData) => {
        return (
            <span className='column'>
                <RiCustomerService2Fill />
                {rowData.customer_service_id}
            </span>
        )

    }
    const componentTotalTransfer = (rowData) => {
        return (
            <span className='column'>
                <BiTransfer />
                {rowData.encaminhados}
            </span>
        )
    }

    function onFilter() {
        if (!search) return
        var aux = data?.filter((obj) => {
            return obj.usuario?.toLowerCase()?.includes(search?.toLowerCase())
                || obj.cliente_id === parseInt(search)
                || obj.customer_service_id === parseInt(search)
                || obj.encaminhados === parseInt(search)
        });
        setDataTable([...aux])
    }
    function onGeneratorExcel() {
        const workbook = XLSX.utils.table_to_book(document.getElementById("IDtable"));
        const ws = workbook.Sheets["Sheet1"];
        XLSX.utils.sheet_add_aoa(ws, [[`Total de Clientes`]], { origin: -1 });
        XLSX.writeFile(workbook,
            `Pesquisa de 
                ${moment(dateStart).format('DD/MM/YYYY')} 
                a 
                ${moment(dateEnd).format('DD/MM/YYYY')}
            .xlsx`
        );

    }

    return (
        <Container>
            <BoxSelect>
                <DatePicker className="date" value={dateStart} onChange={setDateStart} onClick={() => { clear() }} />
                <span> - </span>
                <DatePicker className="date" value={dateEnd} onChange={setDateEnd} onClick={() => { clear() }} />
                <BtnSearch
                    onClick={() => {
                        searchQTDCustomerservice(
                            moment(dateStart).format('DD/MM/YYYY'),
                            moment(dateEnd).format('DD/MM/YYYY')
                        )
                    }}
                >
                    {loading ? <span className='loader' /> : <IoIosSearch />}
                </BtnSearch>
            </BoxSelect>
            <Content>
                <div className='area--cards'>
                    <Card width={`23rem`} height={`5rem`}>
                        <div className='icon--'>
                            <FaUsers />
                        </div>
                        <div className='info--'>
                            <span className='title--'>{`Total de Clientes`}</span>
                            <span className='title-- value'>{qtd?.cliente_id ? qtd?.cliente_id : `--`}</span>
                        </div>
                    </Card>
                    <Card width={`23rem`} height={`5rem`}>
                        <div className='icon--'>
                            <RiCustomerService2Fill />
                        </div>
                        <div className='info--'>
                            <span className='title--'>{`Total de Atendimentos`}</span>
                            <span className='title-- value'>{qtd?.customer_service_id ? qtd?.customer_service_id : `--`}</span>
                        </div>
                    </Card>
                    <Card width={`23rem`} height={`5rem`}>
                        <div className='icon--'>
                            <BiTransfer />
                        </div>
                        <div className='info--'>
                            <span className='title--'>{`Total de Encaminhamentos`}</span>
                            <span className='title-- value'>{qtd?.encaminhados ? qtd?.encaminhados : `--`}</span>
                        </div>
                    </Card>
                </div>
                <div className='area--table'>
                    <Table
                        id={`IDtable`}
                        data={dataTable}
                        keyLine={`usuario_id`}
                        column={[
                            { key: 0, title: 'Usuario', component: componentName },
                            { key: 1, title: 'Clientes Atendidos', component: componentTotalUsers },
                            { key: 2, title: 'Total de Atendimentos', component: componentTotalCustomerService },
                            { key: 3, title: 'Transferências Feitas', component: componentTotalTransfer }
                        ]}
                        search={search}
                        setSearch={setSearch}
                        onFilter={onFilter}
                        onGeneratorExcel={onGeneratorExcel}
                    />
                </div>
            </Content>
        </Container >
    );
}
